import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiLinkedin, FiTwitter, FiInstagram } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-white py-20 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-8 h-8 bg-brand-black rounded-lg flex items-center justify-center group-hover:bg-brand-purple transition-colors">
              <span className="text-white font-black text-xs">RG</span>
            </div>
            <span className="font-black text-xl text-brand-black">RG <span className="text-brand-purple">LEADERSHIP</span></span>
          </Link>
          
          <div className="flex space-x-12 font-black text-sm uppercase tracking-widest text-gray-400">
            <Link to="/services" className="hover:text-brand-purple transition-colors">Services</Link>
            <Link to="/about" className="hover:text-brand-purple transition-colors">About</Link>
            <Link to="/contact" className="hover:text-brand-purple transition-colors">Contact</Link>
          </div>
          
          <div className="flex space-x-4">
            {[FiLinkedin, FiTwitter, FiInstagram].map((Icon, i) => (
              <a key={i} href="#" className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center hover:bg-brand-purple hover:text-white transition-all text-gray-400">
                <SafeIcon icon={Icon} className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-50 text-center text-gray-400 font-bold text-xs uppercase tracking-[0.3em]">
          © {new Date().getFullYear()} RG Leadership Global. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;